import React from 'react';
import uniqueId from '../../../forms/utilities/unique-id';
import { useErrors } from './ErrorsContext';
import Hint from './Hint';
import Label from './Label';
import ValidationError from './ValidationError';

export default function TextQuestion({
    name,
    label = 'Unlabelled',
    value = '',
    onChange = () => {},
    htmlType = 'text',
    autoComplete = 'off',
    hint = null,
    required = true,
    placeholder = null,
    small = false,
}) {
    const id = uniqueId()
    const { errors } = useErrors();

    return <div>
        <Label id={ id } small={ small }>
            { label }
        </Label>

        <input
            id={ name }
            name={ name }
            required={ required }
            className={`block styled-input max-w-sm ${small ? 'mt-1' : 'mt-4'}`}
            autoCapitalize="off"
            autoComplete={ autoComplete }
            type={ htmlType }
            value={ value }
            onChange={ ({ target }) => onChange(target.value)}
            placeholder={ placeholder }
        />

        <Hint hint={ hint } />

        <ValidationError errors={ errors} name={ name } />
    </div>;
}
